(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/models/accordion-structure.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/models/accordion-structure.js');
'use strict';

const accordion = [{
  id: 0,
  title: 'Vad är spelpaus?',
  content: "En aktivering av spelpaus pausar dig fr\xE5n alla spel hos Svenska Spel Sport & Casino. \n    Du v\xE4ljer sj\xE4lv vilket eller vilka spel du vill ta en paus fr\xE5n och hur l\xE5ng paus du vill ta."
}, {
  id: 1,
  title: 'Går det att häva spelpaus?',
  content: 'Nej. Svenska Spel kan inte häva en aktiverad spelpaus innan spelpausperioden är över.'
}, {
  id: 2,
  title: 'När kan jag spela igen?',
  content: "Du kan spela igen n\xE4r spelpausperioden \xE4r \xF6ver. \n    Om du pausat dig 1 \xE5r eller l\xE4ngre beh\xF6ver du kontakta Kundservice f\xF6r att kunna spela igen. \n    Det beror p\xE5 att en paus som \xE4r 1 \xE5r eller l\xE4ngre klassas som en tillsvidareavst\xE4ngning."
}, {
  id: 3,
  title: 'Vem kan jag kontakta om jag har frågor om spelpaus?',
  content: 'Du är alltid välkommen att kontakta vår kundservice.'
}];
svs.selfExclusion.accordion = accordion;

 })(window);